export default __webpack_public_path__ + "static/media/undraw_Social_networking_re_i1ex.eab978bd.svg";